import { render } from "./GrantsSignupForm.vue?vue&type=template&id=67cf6f93"
import script from "./GrantsSignupForm.vue?vue&type=script&lang=js"
export * from "./GrantsSignupForm.vue?vue&type=script&lang=js"

import "./GrantsSignupForm.vue?vue&type=style&index=0&id=67cf6f93&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__